import { Add } from '@mui/icons-material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, Button, IconButton, InputLabel, Typography } from '@mui/material';
import { Fragment, useState } from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import Flex from '@Components/Bases/Flex';
import { FormInput, FormTextEditor } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';

const OtherExplanation = () => {
  const { control } = useFormContext();
  const [indexSelected, setIndexSelected] = useState<number>(0);

  const [isAllCompletedTh, isAllCompletedEn] = useWatch({
    name: ['completedSection.isCompletedTh', 'completedSection.isCompletedEn'],
  });
  const [opened, { open, close }] = useDisclosure();
  const { fields, append, remove } = useFieldArray({
    name: 'otherDescriptions',
  });

  const addFormSection = () => {
    append({
      titleTh: '',
      descriptionTh: '',
      titleEn: '',
      descriptionEn: '',
    });
  };
  const handleOpenDeleteDialog = (otherIndex: number) => {
    setIndexSelected(otherIndex);
    open();
  };

  const handleConfirmDelete = () => {
    remove(indexSelected);
    close();
  };

  return (
    <Box bgcolor={'common.white'} p={2}>
      <Flex justifyContent={'space-between'} alignItems={'center'}>
        <Typography fontWeight={800}>คำบรรยายอื่น ๆ (ถ้ามี)</Typography>
        <Button
          color={'inherit'}
          startIcon={<Add />}
          onClick={addFormSection}
          disabled={isAllCompletedTh || isAllCompletedEn}
        >
          เพิ่มคำบรรยายอื่น ๆ
        </Button>
      </Flex>

      {fields.map((field, index) => (
        <Fragment key={field.id}>
          <Flex
            border={'1px solid hsla(240, 2%, 90%, 1)'}
            borderRadius={1}
            flexDirection={'column'}
            gap={2}
            p={2}
            mt={2}
          >
            <Box>
              <Flex justifyContent={'space-between'} alignItems={'center'}>
                <InputLabel required>คำบรรยายอื่น ๆ (ไทย)</InputLabel>
                <IconButton
                  color="inherit"
                  size="small"
                  onClick={() => handleOpenDeleteDialog(index)}
                  disabled={isAllCompletedTh || isAllCompletedEn}
                >
                  <DeleteOutlineIcon style={{ fontSize: '16px' }} />
                </IconButton>
              </Flex>
              <FormInput
                name={`otherDescriptions.${index}.titleTh`}
                placeholder={'กรุณาระบุหัวข้อ (ไทย)'}
                control={control}
                fullWidth
                sx={
                  isAllCompletedTh
                    ? { ...disabledFormInputStyles, mt: 1 }
                    : { mt: 1 }
                }
                slotProps={{
                  input: {
                    readOnly: isAllCompletedTh,
                  },
                }}
              />
              <FormTextEditor
                name={`otherDescriptions.${index}.descriptionTh`}
                control={control}
                inputProps={{
                  placeholder: 'กรุณาระบุคำบรรยาย (ไทย)',
                }}
                marginTop={1}
                sx={isAllCompletedTh && { ...disabledFormInputStyles }}
              />
            </Box>
            <Box>
              <InputLabel required>คำบรรยายอื่น ๆ (อังกฤษ)</InputLabel>
              <FormInput
                name={`otherDescriptions.${index}.titleEn`}
                placeholder={'กรุณาระบุหัวข้อ (อังกฤษ)'}
                control={control}
                fullWidth
                sx={
                  isAllCompletedEn
                    ? { ...disabledFormInputStyles, mt: 1 }
                    : { mt: 1 }
                }
                slotProps={{
                  input: {
                    readOnly: isAllCompletedEn,
                  },
                }}
              />
              <FormTextEditor
                name={`otherDescriptions.${index}.descriptionEn`}
                inputProps={{ placeholder: 'กรุณาระบุคำบรรยาย (อังกฤษ)' }}
                control={control}
                marginTop={1}
                sx={isAllCompletedEn && { ...disabledFormInputStyles }}
              />
            </Box>
          </Flex>
        </Fragment>
      ))}
      <DeleteModal
        opened={opened}
        close={close}
        confirm={handleConfirmDelete}
        topic="คำบรรยายอื่น ๆ"
      />
    </Box>
  );
};

export default OtherExplanation;
